import { withHydrate } from '@relay/react/hooks';
import React, { useEffect, useState } from 'react';
import { LoaderStyles } from './Loader.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const Loader = ({
  delay,
  theme = 'black'
}) => {
  const [showLoader, setShowLoader] = useState(!delay || delay === 0);
  useEffect(() => {
    if (!delay || delay === 0) {
      return;
    }
    const handle = window.setTimeout(() => setShowLoader(true), delay);
    return () => window.clearTimeout(handle);
  }, []);
  if (!showLoader) {
    return null;
  }
  return /*#__PURE__*/_jsx(LoaderStyles.Wrapper, {
    children: /*#__PURE__*/_jsx(LoaderStyles.Loader, {
      theme: theme
    })
  });
};
export default withHydrate(Loader, 'Loader', 'hybrid');
